import React from "react";
import styled from "styled-components";

import background from '@cover/wachstumstarten/background-1.jpg';
import backgroundSm from '@cover/wachstumstarten/background-1-sm.jpg';
import background2 from '@cover/wachstumstarten/background-2.png';
import background2Sm from '@cover/wachstumstarten/background-2-sm.png';
import WachstumStarten from "../components/cover/animations/wachstumstarten";

export const meta = {
	category: "start",
	slug: "wachstumstarten",
	id: "WachstumStarten",
	name: "wachstumstarten",
	excerpt: {
		before: "Eine Anleitung zur Herstellung von Seedbombs"
	},
	title: "Seedbombs DIY",
	animation: WachstumStarten,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2Sm
				},
				zIndex: 666,
			}
		],
		alt: "Im Muster des goldenen Schnittes entwickelt sich eine Kette von Pflanzenblättern. Der daraus entstehende Kreislauf ähnelt dem Bild eines Globus."
	}
}

const WachstumstartenArticle = () => {
	return (
		<div>
			<p className="articleParagraph">Für 20 Seedbombs braucht man:</p>
			<ul className="articleList">
				<li className="articleListItem">200 g Tonerde, zum Beispiel Heilerde aus der Drogerie</li>
				<li className="articleListItem">200 g Blumenerde</li>
				<li className="articleListItem">3 Päckchen Saatgut verschiedener heimischer Blumensamen</li>
				<li className="articleListItem">Wasser</li>
				<li className="articleListItem">1 Schüssel</li>
				<li className="articleListItem">Zeitungspapier</li>
			</ul>
			<br />
			<ol className="articleList articleList--ordered">
				<li className="articleListItem">Blumensamen vermischen</li>
				<li className="articleListItem">Blumenerde und Tonerde dazu geben</li>
				<li className="articleListItem">Wasser dazu gießen</li>
				<li className="articleListItem">Walnussgroße Kugeln formen</li>
				<li className="articleListItem">Kugeln auf Zeitungspapier etwa 2 Tage trocknen lassen</li>
				<li className="articleListItem">Auswerfen!</li>
			</ol>
		</div>
	)
};

export default WachstumstartenArticle;